var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn",
      attrs: { type: "button", disabled: _vm.disabled || _vm.isLoading },
      on: { click: _vm.onClick },
    },
    [
      _vm.isLoading
        ? _c("strong", [_vm._v("Adicionando ao carrinho...")])
        : _c("strong", { key: _vm.disabled }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.disabled
                    ? "Selecione data, horário e quantidade de ingressos"
                    : "Reservar agora"
                ) +
                "\n  "
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }